import { useAuth } from '../../contexts/AuthContext';

export default function TopBar({ onMenuToggle, pageTitle }) {
  const { signOut } = useAuth();

  return (
    <header className="sticky top-0 z-30 bg-white/97 backdrop-blur-[20px] border-b border-vault-border">
      <div className="flex items-center justify-between px-5 lg:px-8 py-3.5">
        {/* Mobile menu button */}
        <button
          onClick={onMenuToggle}
          className="lg:hidden p-2 -ml-2 text-gray-400 hover:text-vault-navy rounded-input transition-colors"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>

        {/* Spacer */}
        <div className="hidden lg:block" />

        {/* Right side */}
        <div className="flex items-center gap-3">
          {/* Notification bell */}
          <button className="relative p-2 text-gray-400 hover:text-vault-navy rounded-input transition-colors">
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9" />
            </svg>
          </button>

          {/* Sign out */}
          <button
            onClick={signOut}
            className="btn-tertiary btn-sm"
          >
            Sign out
          </button>
        </div>
      </div>
    </header>
  );
}
